"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastNotification = exports.ToastType = void 0;
const react_1 = __importStar(require("react"));
const atoms_1 = require("../../atoms");
const solid_1 = require("@heroicons/react/20/solid");
const react_2 = require("@headlessui/react");
var ToastType;
(function (ToastType) {
    ToastType["SUCCESS"] = "success";
    ToastType["ERROR"] = "error";
    ToastType["INFO"] = "info";
    ToastType["WARNING"] = "warning";
    ToastType["TIP"] = "tip";
})(ToastType = exports.ToastType || (exports.ToastType = {}));
function ToastNotification({ type = ToastType.INFO, message, description, onDismiss, onUndo, closeable = true, }) {
    const [show, setShow] = react_1.default.useState(false);
    const dismiss = () => {
        setShow(false);
        setTimeout(() => {
            onDismiss && onDismiss();
        }, 200);
    };
    const undo = () => {
        onUndo && onUndo();
        dismiss();
    };
    (0, react_1.useEffect)(() => {
        setShow(true);
        const timer = setTimeout(dismiss, 5000);
        return () => clearTimeout(timer);
    }, []);
    const iconByType = {
        [ToastType.SUCCESS]: (react_1.default.createElement(solid_1.CheckCircleIcon, { className: "h-6 w-6 text-[#23922F]", "aria-hidden": "true" })),
        [ToastType.ERROR]: (react_1.default.createElement(solid_1.ExclamationTriangleIcon, { className: "h-6 w-6 text-[#C01F05]", "aria-hidden": "true" })),
        [ToastType.INFO]: (react_1.default.createElement(solid_1.InformationCircleIcon, { className: "h-6 w-6 text-[#2841ED]", "aria-hidden": "true" })),
        [ToastType.WARNING]: (react_1.default.createElement(solid_1.ExclamationCircleIcon, { className: "h-6 w-6 text-[#E29036]", "aria-hidden": "true" })),
        [ToastType.TIP]: (react_1.default.createElement(solid_1.LightBulbIcon, { className: "h-6 w-6 text-[#3E4758]", "aria-hidden": "true" })),
    };
    const textColorByType = {
        [ToastType.SUCCESS]: 'text-[#23922F]',
        [ToastType.ERROR]: 'text-[#EF463B]',
        [ToastType.INFO]: 'text-[#2841ED]',
        [ToastType.WARNING]: 'text-[#B36B27]',
        [ToastType.TIP]: 'text-[#2A313F]',
    };
    return (react_1.default.createElement(react_2.Transition, { show: show, as: react_1.Fragment, enter: "transform ease-out duration-300 transition", enterFrom: "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2", enterTo: "translate-y-0 opacity-100 sm:translate-x-0", leave: "transition ease-out duration-200", leaveFrom: "opacity-100", leaveTo: "opacity-0" },
        react_1.default.createElement("div", { className: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-default ring-1 ring-black ring-opacity-5" },
            react_1.default.createElement("div", { className: "p-4" },
                react_1.default.createElement("div", { className: "flex items-start" },
                    react_1.default.createElement("div", { className: "flex-shrink-0" }, iconByType[type]),
                    react_1.default.createElement("div", { className: "ml-3 w-0 flex-1 pt-0.5" },
                        react_1.default.createElement(atoms_1.Text, { type: atoms_1.TextType.HEADING_S, className: textColorByType[type] }, message),
                        description && (react_1.default.createElement(atoms_1.Text, { type: atoms_1.TextType.BODY_S, subdued: true, className: "mt-1 text-[#2A313F]" }, description))),
                    react_1.default.createElement("div", { className: "ml-4 flex flex-shrink-0" },
                        onUndo && type === ToastType.SUCCESS && (react_1.default.createElement("button", { type: "button", className: "bg-none mr-2", onClick: undo },
                            react_1.default.createElement(atoms_1.Text, { type: atoms_1.TextType.UI_ELEMENT, className: "text-[#3E4758] cursor-pointer" }, "Undo"))),
                        closeable && (react_1.default.createElement("button", { type: "button", className: "inline-flex rounded-md bg-none text-icon-disabled", onClick: dismiss },
                            react_1.default.createElement("span", { className: "sr-only" }, "Close"),
                            react_1.default.createElement(solid_1.XMarkIcon, { className: "h-6 w-6", "aria-hidden": "true" })))))))));
}
exports.ToastNotification = ToastNotification;
//# sourceMappingURL=ToastNotification.js.map